export function getErrorMessage(status: number): string {
  switch (status) {
    case 403:
      return 'You are not authorized to use this tool.';
    case 404:
      return 'Not found!';
    case 500:
      return 'Internal Server Error';
    default:
      return 'An unexpected error occurred';
  }
}
